import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=94b6e4ec&scoped=true&"
import script from "./Blank.vue?vue&type=script&lang=js&"
export * from "./Blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b6e4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b6e4ec')) {
      api.createRecord('94b6e4ec', component.options)
    } else {
      api.reload('94b6e4ec', component.options)
    }
    module.hot.accept("./Blank.vue?vue&type=template&id=94b6e4ec&scoped=true&", function () {
      api.rerender('94b6e4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Blank.vue"
export default component.exports